import packageInfo from "../package.json";

export function getVersion(): string {
  // @ts-ignore
  if (typeof CODEBUILD_BUILD_NUMBER !== "undefined")
    // @ts-ignore
    return CODEBUILD_BUILD_NUMBER;

  return packageInfo.version
    .split(".")
    .splice(2)
    .join();
}
